define([
    'angularTable'

], ()=> {
    return angular.module('edge.platform.widgets.table', ['angular-table']);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/list/module.js
 **/